import React from 'react';
import { Box, Container, Typography, Button, Paper, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';

const MIDNIGHT   = '#1A1A2E';
const GOLD       = '#C9973A';
const FOREST     = '#4A6741';
const WALNUT     = '#2C1F14';
const PARCHMENT  = '#F7F3EE';

export default function BikeTravelBookingSuccess() {
    return (
        <Box sx={{
            minHeight: '100vh',
            background: `linear-gradient(rgba(247,243,238,0.92), rgba(247,243,238,0.92))`,
            display: 'flex', alignItems: 'center',
        }}>
            <Container maxWidth="sm">
                <Paper elevation={0} sx={{
                    p: { xs: 4, md: 6 },
                    borderRadius: 4,
                    border: `1px solid rgba(201,151,58,0.3)`,
                    boxShadow: '0 8px 40px rgba(26,26,46,0.1)',
                    textAlign: 'center',
                }}>
                    <Box sx={{
                        width: 72, height: 72, borderRadius: '50%',
                        bgcolor: 'rgba(74,103,65,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        mx: 'auto', mb: 3,
                    }}>
                        <CheckCircleIcon sx={{ fontSize: '2.5rem', color: FOREST }} />
                    </Box>

                    <Typography variant="h4" fontWeight={900}
                                sx={{ color: WALNUT, fontFamily: "'Playfair Display', Georgia, serif", mb: 1 }}>
                        Payment Successful!
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#4A3728', mb: 3, lineHeight: 1.8 }}>
                        Your booking has been confirmed. Our team will reach out to you with further details
                        about your journey.
                    </Typography>

                    <Paper elevation={0} sx={{
                        p: 2.5, mb: 3, borderRadius: 2,
                        bgcolor: 'rgba(201,151,58,0.06)',
                        border: `1px solid rgba(201,151,58,0.25)`,
                        textAlign: 'left',
                    }}>
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <DirectionsBikeIcon sx={{ color: GOLD, fontSize: '1.3rem' }} />
                            <Box>
                                <Typography variant="body2" fontWeight={700} sx={{ color: WALNUT }}>
                                    What happens next?
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#4A3728', lineHeight: 1.6 }}>
                                    If you paid a 30% deposit, remember to complete the remaining 70%
                                    at least 15 days before your start date — otherwise your booking
                                    will be automatically cancelled.
                                </Typography>
                            </Box>
                        </Stack>
                    </Paper>

                    <Stack spacing={1.5} direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
                        <Button
                            variant="contained"
                            component="a"
                            href="/my-bookings"
                            sx={{
                                background: `linear-gradient(135deg, ${MIDNIGHT} 0%, #2A2A4E 100%)`,
                                color: GOLD, borderRadius: 2, fontWeight: 700, px: 3,
                            }}>
                            View My Bookings
                        </Button>
                        <Button
                            variant="outlined"
                            component="a"
                            href="/bike-travel-offers"
                            sx={{ borderColor: MIDNIGHT, color: MIDNIGHT, borderRadius: 2, fontWeight: 700, px: 3 }}>
                            Browse More Offers
                        </Button>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}
